import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
// import {submitProvince, updateProvince} from "../../../services/consultationPayment/consultationPayment";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {updateReservationFinish} from "../../services/reservation/reservation";

export function ConsultationPaymentForm({consultationPayment, open, setOpen, setLastDataRefresh, setGridSelectedRow}) {
  const handleOpen = () => setOpen(!open);

  const [id, setId] = useState(null)
  const [personName, setPersonName] = useState("")
  const [personPhone, setPersonPhone] = useState("")
  const [agentName, setAgentName] = useState("")
  const [agentPhone, setAgentPhone] = useState("")
  const [branchTitle, setBranchTitle] = useState("");
  const [date, setDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [duration, setDuration] = useState("")

  useEffect(() => {
    setId(consultationPayment?.id ?? null);
    setPersonName(consultationPayment?.person_name ?? "");
    setPersonPhone(consultationPayment?.person_phone ?? "");
    setAgentName(consultationPayment?.agent_name ?? "");
    setAgentPhone(consultationPayment?.agent_phone ?? "");
    setBranchTitle(consultationPayment?.branch_title ?? "");
    setDate(consultationPayment?.date ?? "");
    setStartTime(consultationPayment?.start_time ?? "");
    setEndTime(consultationPayment?.end_time ?? "");
    setDuration(consultationPayment?.duration ?? "");
  }, [consultationPayment]);

  const save = async () => {
    const data = {
      id: id,
    };

    let result;

    result = await updateReservationFinish(data);

    if (result.status === 200) {
      setGridSelectedRow(false)
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  return (
    <>
      <Dialog open={open} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>بررسی</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

          <div className="grid grid-cols-1 gap-y-4 md:grid-cols-2">

            <div className="pb-4 border-b-2">
              <Typography color="blue-gray">
                {`کاربر: ${personName}`}
              </Typography>
            </div>

            <div className="pb-4 border-b-2">
              <Typography color="blue-gray">
                {`موبایل کاربر: ${persianNumberFormat(personPhone)}`}
              </Typography>
            </div>

            <div className="pb-4 border-b-2">
              <Typography color="blue-gray">
                {`مباشر: ${agentName}`}
              </Typography>
            </div>

            <div className="pb-4 border-b-2">
              <Typography color="blue-gray">
                {`موبایل مباشر: ${persianNumberFormat(agentPhone)}`}
              </Typography>
            </div>

            <div className="pb-4 border-b-2">
              <Typography color="blue-gray">
                {`گرایش: ${branchTitle}`}
              </Typography>
            </div>

            <div className="pb-4 border-b-2">
              <Typography color="blue-gray">
                {`تاریخ: ${persianNumberFormat(date)}`}
              </Typography>
            </div>

            <div className="pb-4 border-b-2">
              <Typography color="blue-gray">
                {`زمان: ${persianNumberFormat(startTime)} - ${persianNumberFormat(endTime)}`}
              </Typography>
            </div>

            <div className="pb-4 border-b-2">
              <Typography color="blue-gray">
                {`مدت: ${persianNumberFormat(duration)}`}
              </Typography>
            </div>

          </div>

        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>انصراف</span>
          </Button>
          <Button variant="gradient" color="gray" onClick={save} className="ml-1">
            <span>تایید اتمام جلسه</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}